<template>
  <div class="fix-app">
    <v-app-bar color="primary " class="app-bar ">
      <!-- <v-toolbar-title>
        ใส่ใจวัยเก่า
      </v-toolbar-title> -->
      <v-spacer></v-spacer>
      <v-container class="logo-container">
        <v-img
          aspect-ratio="16/9"
          cover
          :src="require('../assets/logo/Saijailogo.png')"
          class="logo-img"
        />

        <!-- <v-img aspect-ratio="16/9" class="d-none d-sm-block"
      cover
      :src="require('../assets/Saijailogo2.png')" 
      /> -->
      </v-container>

      <v-spacer></v-spacer>

      <template v-if="$vuetify.display.mdAndUp">
        <v-btn
          v-for="(item, i) in items"
          :to="item.href"
          :key="i"
          :prepend-icon="item.icon"
          >{{ item.title }}</v-btn
        >
        <v-spacer></v-spacer>
      </template>

      <template v-else>
        <v-app-bar-nav-icon
          class="pr-7"
          variant="text"
          size="auto"
          @click.stop="drawer = !drawer"
        ></v-app-bar-nav-icon>
      </template>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      temporary
      width="200"
      color="light-blue darken-2"
      location="right"
    >
      <v-list-item>
        <template v-slot:append> ใส่ใจวัยเก๋า </template>
      </v-list-item>

      <v-divider></v-divider>
      <!---^^^-->

      <v-list
        v-for="item in items"
        :key="item.title"
        link
        density="compact"
        nav
      >
        <!----------------vvv ----------------->

        <v-list-item
          :prepend-icon="item.icon"
          :title="item.title"
          :value="item.href"
          :to="item.href"
        ></v-list-item>
        <!-- <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>-->

        <!----------------^^^ ----------------->
      </v-list>
    </v-navigation-drawer>




  </div>
</template>

<script  >
import { homeItems } from "../router/linkScript";
export default {
  data: () => ({
    drawer: false,
    group: null,

    items: homeItems,
    value: 1,
  }),

  watch: {
    group() {
      this.drawer = false;
    },
  },


};
</script>

